import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFTextField, RHFAutocomplete } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography, createFilterOptions } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export default function CandNewEditCertiCompo({ certInstNmArr, certNmArr }) {
  const genderArr = ['Male', 'Female'];
  // const [genderArr, setGenderArr] = useState([]);
  const { control, setValue, watch, resetField, trigger } = useFormContext();
  const filter = createFilterOptions();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'candCert',
  });

  const handleAdd = () => {
    append({
      cerSrno: 0,
      certiNm: '',
      certiInstiNm: '',
      certfromDate: null,
      certtoDate: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        <Typography variant="h6" sx={{ color: 'text.disabled' }}>
          Certification Details:
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Certificate
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="h6" sx={{ color: 'primary', mb: 2 }}>
              Certificate {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
              <RHFTextField name={`candCert[${index}].cerSrno`} />
            </Box>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              {/* <RHFTextField
                name={`candCert[${index}].certiNm`}
                label={
                  <div>
                    Certification Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              /> */}
              <RHFAutocomplete
                name={`candCert[${index}].certiNm`}
                label={
                  <div>
                    Certification Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
                disableClearable
                options={certNmArr}
                showPlusIcon
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== '') {
                    filtered.push(`${params.inputValue}`);
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                // value={selectedCurLoc}
                // onChange={(event, newValue) => {
                //   setSelectedCurLoc(newValue);
                // }}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setValue(`candCert[${index}].certiNm`, newValue);
                  } else if (newValue && newValue.inputValue) {
                    setValue(`candCert[${index}].certiNm`, newValue.inputValue);
                  } else {
                    setValue(`candCert[${index}].certiNm`, newValue);
                  }
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
              />
              {/* <RHFTextField name={`candCert[${index}].certiInstiNm`} label="Institute Name" /> */}
              <RHFAutocomplete
                name={`candCert[${index}].certiInstiNm`}
                label="Institute Name"
                disableClearable
                options={certInstNmArr}
                showPlusIcon
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setValue(`candCert[${index}].certiInstiNm`, newValue);
                  } else if (newValue && newValue.inputValue) {
                    setValue(`candCert[${index}].certiInstiNm`, newValue.inputValue);
                  } else {
                    setValue(`candCert[${index}].certiInstiNm`, newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== '') {
                    filtered.push(`${params.inputValue}`);
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                // value={selectedCurLoc}
                // onChange={(event, newValue) => {
                //   setSelectedCurLoc(newValue);
                // }}
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
              />
              <Controller
                name={`candCert[${index}].certfromDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label="From Date"
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`candCert[${index}].certtoDate`);
                      trigger(`candCert[${index}].certfromDate`);
                    }}
                   
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                    maxDate={new Date()}
                  />
                )}
              />
              <Controller
                name={`candCert[${index}].certtoDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label="To Date"
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`candCert[${index}].certfromDate`);
                      trigger(`candCert[${index}].certtoDate`);
                    }}
                   
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                  />
                )}
              />
            </Box>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
CandNewEditCertiCompo.propTypes = {
  certNmArr: PropTypes.array,
  certInstNmArr: PropTypes.array,
};
